// extracted by mini-css-extract-plugin
export default {"Wraper":"Pages_Wraper__+A9sd","MainContainer":"Pages_MainContainer__Dspzk","PagesMenu":"Pages_PagesMenu__Totj0","Page":"Pages_Page__2Gdmp","PageIcon":"Pages_PageIcon__fUDE5"};